import { css } from '@microsoft/fast-element';

export const CenteredModalStyles = css`
  :host {
    position: relative;
  }

  .centered-dialog {
    --fill-color: var(--neutral-layer-3);
  }

  .centered-dialog::part(control) {
    --dialog-height: none;
    --dialog-width: 554px;
    border-radius: 6px;
    border: 1px solid #2e3339;
    background-color: #1c2024;
    box-sizing: border-box;
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.35);
    position: relative;
    padding: 28px;
  }

  .centered-dialog .header {
    height: 56px;
    font-size: 18px;
    color: var(--white);
    border-bottom: 1px solid var(--border-1);
    display: flex;
    align-items: center;
    padding: 0 0 0 16px;
  }

  .closing-icon {
    background: transparent;
    border: none;
    height: 32px;
    margin: 0;
    min-width: 32px;
    position: absolute;
    right: 15px;
    top: 12px;
  }

  .closing-icon:hover {
    background: var(--button-hover-bg);
  }

  .closing-icon::part(control):focus-visible {
    border: none;
    box-shadow: none;
  }

  .closing-icon:hover svg path {
    fill: var(--white);
  }

  .header-left {
    background: transparent;
    border: none;
    height: 32px;
    margin: 0;
    min-width: 32px;
  }
`;
